import { isCompletedSourceStatus } from './collaborationDisplayStatus';

export function isCancelledJourneyAcceptance(acceptanceStatus, rowStatus) {
  return acceptanceStatus === 'cancelled'
    || acceptanceStatus === 'canceled'
    || rowStatus === 'cancelled'
    || rowStatus === 'canceled';
}

export function getJourneyDetailKey(isApplication, id) {
  return `${isApplication ? 'application' : 'invite'}_${id}`;
}

/** KPI / list page step source — merges acceptance without completed-status normalization. */
export function resolveSimpleJourneyStepSource(item, acceptanceDetail) {
  if (acceptanceDetail) {
    return { ...item, ...acceptanceDetail, status: acceptanceDetail.status || item.status };
  }
  if (item.status === 'approved') {
    return { ...item, status: 'accepted' };
  }
  return item;
}

/**
 * Overview / work-queue step source — forces completed when any status source says so.
 */
export function resolveCompletedAwareJourneyStepSource(
  item,
  acceptanceDetail,
  acceptanceStatus,
  rowStatus,
) {
  if (acceptanceDetail) {
    const mergedStatus = acceptanceDetail.status || item.status;
    const status = isCompletedSourceStatus(rowStatus)
      || isCompletedSourceStatus(mergedStatus)
      || isCompletedSourceStatus(acceptanceStatus)
      ? 'completed'
      : mergedStatus;
    return { ...item, ...acceptanceDetail, status };
  }
  if (item.status === 'approved') {
    return { ...item, status: 'accepted' };
  }
  return item;
}

export function getBrandAcceptanceStatus(acceptanceDetail) {
  return acceptanceDetail?.acceptanceStatus?.toLowerCase?.()
    || acceptanceDetail?.status?.toLowerCase?.();
}

export function getInfluencerAcceptanceStatus(acceptanceDetail) {
  return acceptanceDetail?.status?.toLowerCase?.();
}
